import { ref, get } from "firebase/database";
import { db } from "../firebase/firebaseconfig"; // Đường dẫn file config của bạn

export const generateSitemap = async () => {
  const domain = "https://habakome-6d2ee.web.app/"; // Thay bằng tên miền của bạn
  let xml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">`;

  // Danh sách các node cần lấy link
  const nodes = ["projects", "news", "products"];
  
  for (const node of nodes) {
    const snapshot = await get(ref(db, node));
    if (snapshot.exists()) {
      const data = snapshot.val();
      Object.values(data).forEach((item) => {
        if (item.slug) {
          // Xác định tiền tố đường dẫn (ví dụ: /du-an/, /tin-tuc/)
          const prefix = node === "projects" ? "du-an" : (node === "news" ? "tin-tuc" : "san-pham");
          xml += `
  <url>
    <loc>${domain}/${prefix}/${item.slug}</loc>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>`;
        }
      });
    }
  }

  xml += `\n</urlset>`;
  
  // Tự động tải file xuống máy
  const blob = new Blob([xml], { type: "text/xml" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "sitemap.xml";
  a.click();
};